import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankCancelPage} from 'features/saved-accounts/pages/ConnectBankCancelPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/connect-bank/cancel',
)({
  component: ConnectBankCancelPage,
});
